<template>
    <div class="ctotal bgps flex">
      <div
        v-for="(i, j) in newarr"
        :key="j"
        class="f1 flex ac"
        @click="tabclick(j)"
        :style="{
          // background: i.select == 1 ? 'rgba(255,255,255,.2)' : '',
          color: i.select == 1 ? 'white' : '',
        }"
      >
        {{ i.label }}
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
    titlearr:{
      default:[]
    }
  },
    data() {
      return {
        newarr: [],
        url:this.backgroundurl
      };
    },
    methods: {
      mixarr() {
        this.newarr = [];
        this.titlearr.forEach((e) => {
          this.newarr.push({ label: e, select: 0 });
        });
        this.newarr[0].select = 1;
      },
      tabclick(e) {
        for (let i in this.newarr) {
          if (e == i) {
            this.newarr[i].select = 1;
          } else {
            this.newarr[i].select = 0;
          }
        }
      },
    },
    created() {
      this.mixarr();
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .ctotal {
    width: 100%;
    justify-content: flex-start;
    align-items: center;
    height: 2.3vw;
    font-size: .78vw;
    text-indent: 1.04vw;
    padding-bottom: 0.6vw;
    background: url("../../assets/image/video/long.png") no-repeat;
  }
  </style>
  